import { render, staticRenderFns } from "./ScoutTopicRecommendation.vue?vue&type=template&id=37d1fccf"
import script from "./ScoutTopicRecommendation.vue?vue&type=script&lang=js"
export * from "./ScoutTopicRecommendation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports